import { render, staticRenderFns } from "./App.vue?vue&type=template&id=325acdf9&scoped=true&"
import script from "./App.vue?vue&type=script&setup=true&lang=js&"
export * from "./App.vue?vue&type=script&setup=true&lang=js&"
import style1 from "./App.vue?vue&type=style&index=1&id=325acdf9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325acdf9",
  null
  
)

export default component.exports